import React from "react";

function Info({ width = 20, height = 20, fill = "#7C6060" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_201_87620)">
        <path
          d="M9.99935 1.6665C5.39935 1.6665 1.66602 5.39984 1.66602 9.99984C1.66602 14.5998 5.39935 18.3332 9.99935 18.3332C14.5993 18.3332 18.3327 14.5998 18.3327 9.99984C18.3327 5.39984 14.5993 1.6665 9.99935 1.6665ZM10.8327 14.1665H9.16602V9.1665H10.8327V14.1665ZM10.8327 7.49984H9.16602V5.83317H10.8327V7.49984Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_201_87620">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Info;
